export const validInputClassMap: Record<string, string> = {
  input: "right-4",
  select: "right-12",
} as const;

export type ValidInputInputType = keyof typeof validInputClassMap;
